import { CRUDButtons } from 'components/CRUDButtons';
import { Alignment, Column, ColumnType } from 'components/Table/types/column';
import { FormattedNumberCell } from 'routes/Risk/components/FormattedNumberCell';
import { NestedRow } from 'routes/Risk/components/HierarchyCell';
import { SymbolTableRow } from 'types/risk';

interface RiskColumnsConfig {
  readonly canEdit: boolean;
}

export const createRiskColumns = ({
  canEdit,
}: RiskColumnsConfig): Array<Column<SymbolTableRow>> => [
  {
    minWidth: 48,
    weight: 0.0001,
    columnType: ColumnType.custom,
    key: 'id',
    filterable: false,
    header: '',
    textuallyOverlap(value: any, keyword: string): boolean {
      return value.includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return v1.localeCompare(v2);
    },
    component: (props) => <CRUDButtons {...props} showDelete={false} disableEdit={!canEdit} />,
  },
  {
    key: 'account',
    columnType: ColumnType.custom,
    header: 'Account',
    weight: 1,
    alignment: Alignment.left,
    editable: false,
    filterable: true,
    sortingDifference(v1: string, v2: string): number {
      return v1.localeCompare(v2);
    },
    textuallyOverlap(value: string, keyword: string): boolean {
      return value.includes(keyword);
    },
    component: (props) => <NestedRow account={props} limitType="symbol" />,
  },
  {
    key: 'symbol',
    columnType: ColumnType.text,
    alignment: Alignment.center,
    header: 'Symbol',
    editable: true,
    filterable: true,
    textuallyOverlap(value: any, keyword: string): boolean {
      return value.includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return v1.localeCompare(v2);
    },
  },
  {
    key: 'maxqty',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Max Qty',
    editable: true,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
  {
    key: 'commrate',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Comm Rate',
    editable: true,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
  {
    key: 'maxpercentaway',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Max Price % Away',
    editable: true,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
  {
    key: 'maxnotional',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Max Notional',
    editable: true,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
];
